"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tailCallOptimize = tailCallOptimize;
exports.getPathByCursorIndexFromAst = getPathByCursorIndexFromAst;
exports.binaryRecursionToArray = exports.compareIgnoreLowerCaseWhenString = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var compareIgnoreLowerCaseWhenString = function compareIgnoreLowerCaseWhenString(source, target) {
  if (typeof source === 'string' && typeof target === 'string') {
    return source.toLowerCase() === target.toLowerCase();
  }

  return source === target;
};

exports.compareIgnoreLowerCaseWhenString = compareIgnoreLowerCaseWhenString;

var binaryRecursionToArray = function binaryRecursionToArray(ast) {
  if (ast[1]) {
    return [ast[0]].concat(ast[1][1]);
  }

  return [ast[0]];
};

exports.binaryRecursionToArray = binaryRecursionToArray;

function tailCallOptimize(f) {
  var value;
  var active = false;
  var accumulated = [];
  return function accumulator() {
    accumulated.push(arguments);

    if (!active) {
      active = true;

      while (accumulated.length) {
        value = f.apply(this, accumulated.shift());
      }

      active = false;
      return value;
    }
  };
}

function getPathByCursorIndexFromAst(obj, cursorIndex, path) {
  path = path || '';
  var fullpath = '';

  for (var key in obj) {
    if (obj[key] && obj[key].token === true && obj[key].position[0] <= cursorIndex && obj[key].position[1] + 1 >= cursorIndex) {
      if (path === '') {
        return key;
      }

      return "".concat(path, ".").concat(key);
    }

    if ((0, _typeof2["default"])(obj[key]) === 'object') {
      fullpath = getPathByCursorIndexFromAst(obj[key], cursorIndex, path === '' ? key : "".concat(path, ".").concat(key)) || fullpath;
    }
  }

  return fullpath;
}